// Les conditions d'utilisation (CNX-E06). Une nouvelle version demande l'accord de chaque compte a sa connexion
// suivante (decision de Boris, 2026-11-01).

/** La version en vigueur des CGU */
export const CGU_VERSION = 2;

/** Sa date d'entree en vigueur : la mise en production du chantier CNX */
export const CGU_EFFECTIVE_DATE = '2026-11-01';
/** La version precedente, citee par les CGU */
export const CGU_PREVIOUS = { version: 1, date: '2026-03-29' };

/**
 * L'adresse ou exercer ses droits : celle de Boris pour l'instant (decision du 2026-11-01) ; l'adresse dediee
 * contact@archifacil.com est a creer, puis a mettre ici (FIX-075).
 */
export const CONTACT_EMAIL = 'boris.helvas@gmail.com';

export function needsCguAcceptance(version: number | null | undefined): boolean {
  return !version || version < CGU_VERSION;
}

/** Les textes legaux : publics, lisibles sans compte ni acceptation */
export const LEGAL_PATHS = ['/cgu', '/confidentialite'];

/** Le chemin est cette page ou l'une de ses sous-pages (« /cgu », pas « /cguX ») */
export function isUnder(pathname: string, prefix: string): boolean {
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

/** Ce que la page d'acceptation laisse passer : textes legaux, centre d'aide, et elle-meme */
const OPEN_PATHS = [...LEGAL_PATHS, '/aide', '/conditions/accepter'];

/**
 * La decision du proxy : une page demandee par un compte qui n'a pas accepte la version en vigueur va a l'ecran
 * d'acceptation, avec l'adresse demandee pour y revenir. Les routes d'API ne sont jamais redirigees.
 */
export function cguGate(pathname: string, search: string, version: number | null | undefined): string | null {
  if (!needsCguAcceptance(version)) return null;
  if (pathname.startsWith('/api/')) return null;
  if (OPEN_PATHS.some((p) => isUnder(pathname, p))) return null;
  return `/conditions/accepter?next=${encodeURIComponent(pathname + search)}`;
}

/** Les champs d'une acceptation de la version en vigueur (inscription, ecran d'acceptation) */
export function cguAcceptance(now = new Date()) {
  return { cguVersion: CGU_VERSION, cguAcceptedAt: now };
}

/** L'adresse ou revenir apres l'acceptation : une page de l'application seulement (pas de redirection ouverte) */
export function safeNext(next: string | null, origin: string): string {
  if (!next) return '/';
  try {
    const url = new URL(next, origin);
    return url.origin === origin ? url.pathname + url.search + url.hash : '/';
  } catch {
    return '/';
  }
}

/** « 1er décembre 2026 » */
export function formatLegalDate(iso: string): string {
  return new Date(`${iso}T12:00:00Z`)
    .toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' })
    .replace(/^1 /, '1er ');
}
